import React from 'react';
import { Redirect } from 'react-router-dom';

const HomePage = (): JSX.Element => <Redirect to={{ pathname: '/searchPage' }} />;

export default HomePage;
